export const sleep=a=>new Promise(b=>setTimeout(b,a));export default{sleep};